import { render, staticRenderFns } from "./SCM.vue?vue&type=template&id=ab5bc67c&scoped=true&"
import script from "./SCM.vue?vue&type=script&lang=js&"
export * from "./SCM.vue?vue&type=script&lang=js&"
import style0 from "./SCM.vue?vue&type=style&index=0&id=ab5bc67c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5bc67c",
  null
  
)

export default component.exports